// 定义树状结构的函数
export function createTree(list) {
    console.log(list)
    const result = list.reduce(function (prev, curr, i, arr) {
        curr.children = arr.filter((v) => v.parentId === curr.id);
        if (curr.parentId === '0') {
            prev.push(curr);
        }
        return prev;
    }, [])
    return result
}

export function createCategoryTree(list) {
    list = list.map((item) => {
        return {
            value: item.categoryId,
            label: item.categoryName,
            parentId: item.parentCategoryId,
        }
    })
    const result = list.reduce(function (prev, curr, i, arr) {
        curr.children = arr.filter((v) => v.parentId === curr.value);
        if (!curr.parentId) {
            prev.push(curr);
        }
        return prev;
    }, [])
    return result.filter((v) => v.children.length > 0);
}